import { useTranslate } from '@tolgee/react';
import { WidgetWrapper } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';

export function PartnerNavigationWidget(props: Props) {
  const { t } = useTranslate();

  if (!props.items?.length) {
    return (
      <WidgetWrapper>
        <EmptyState
          title={'Navigation'}
          description={t('partner_no_content_available')}
        />
      </WidgetWrapper>
    );
  }

  return (
    <WidgetWrapper>
      <div className="flex flex-row gap-8 flex-wrap">
        <div className="flex flex-col items-start gap-2">
          <img
            src={`https://immo.agentselly.ch/assets/partner/${
              props.companyId || '70927429839'
            }/logo.svg`}
            className="w-auto h-8"
            alt=""
          />
          <span className="flex flex-row items-center gap-2 text-sm">
            <span>by</span>
            <img
              src="https://immo.agentselly.ch/assets/partner/70927429839/logo.svg"
              className="w-auto h-4"
              alt=""
            />
          </span>
        </div>
        <ul className="hidden md:flex flex-row flex-wrap gap-2">
          {props.items.map((item) => (
            <li key={item.link}>
              <a
                href={item.link}
                className="block px-4 py-2 text-primary-900 hover:bg-primary-100"
              >
                {t(item.label)}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </WidgetWrapper>
  );
}

interface Props {
  readonly companyId: string;
  readonly items: {
    readonly link: string;
    readonly label: string;
  }[];
}
